module.exports = __webpack_public_path__ + "static/media/table-with-teakettle-green-vase-and-red-flowers.dea74f9a.jpg";